import React, { useEffect, useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom';
import { Button, Card, TextField, Container, IconButton, MenuItem, Popover, FormControl, InputLabel, Select, Stack, Typography } from '@mui/material'
import Iconify from '../components/iconify';
import { fetchmanagetolerancelist, addmanagetolerancelist, deletemanagetolerancelist, ByIdFetchmanagetolerance, Editmanagetolerance, getqualitymaterialcode, fetchqualitydetails } from './qualityApi';
import { capitalizeFunction, typeNumberValid } from '../../common/commonValidations';
import { DataGrid } from '@mui/x-data-grid';
import { QuickSearchToolbar } from '../../payment/common/commonFunctions';
import { Box } from '@mui/material'
import { Add as AddIcon, Search as SearchIcon } from '@mui/icons-material';
import { fDate } from '../../common/common-sidebar/utils/formatTime';
import { toast } from 'react-toastify';
import { ConfirmationPopover } from '../../common/commonPopovers/confirmationPopover';
import { handleNumberFieldFocus } from '../../common/commonFunction';

export default function ManageTolerance() {
  const navigate = useNavigate();
  const [details, setDetails] = useState({
    qualityParameter: '',
    materialCode: '',
    toleranceLimit: '',
    unitOfMeasurement: '%',
    QualityparameterText: '',
    minValue: '',
    maxValue: ''
  });
  const [fetchdetails, setFetchDetails] = useState([]);
  const [alltolerancelists, setAllToleranceLists] = useState([]);
  // const [isLoading, setLoading] = useState(true);
  const [open, setOpen] = useState(null);
  const [openId, setOpenId] = useState(null);
  const [deletetolerancelists, setDeleteToleranceLists] = useState([]);
  const [isEdit, setEdit] = useState(false);
  const [editId, setEditId] = useState(null);
  const [qualityParamDetails, setQualityParamDetails] = useState([]);
  const [allMaterialCode, setAllMaterialCode] = useState([]);
  const [showQuaparam, setShowQuaparam] = useState(false);
  const [addtolerancelists, setAddToleranceLists] = useState([]);
  const [isAdd, setAdd] = useState(false);
  const [showAdd, SetshowAdd] = useState(true);
  const current = new Date();
  const date = `${current.getDate()}/${current.getMonth() + 1}/${current.getFullYear()}`;
  let checkUserDetails = localStorage.getItem('role');
  const [showRange, setShowRange] = useState(false);
  const [showTolaranceLimit, setShowTolaranceLimit] = useState(false);
  const [selectedRow, setSelectedRow] = useState();
  const [fetchbyidtolerancelists, setFetchByIdToleranceLists] = useState([]);
  const [edittolerancelists, setEditToleranceLists] = useState([]);
  const [logModalOpenDelete, setLogModalOpenDelete] = useState(false);
  const handleLogModalCloseDelete = () => setLogModalOpenDelete(false);
  const handleLogModalOpenDelete = () => setLogModalOpenDelete(true);
  const [selectedId, setSelectedId] = useState();
  const [logModalOpenSubmit, setLogModalOpenSubmit] = useState(false);
  const handleLogModalCloseSubmit = () => setLogModalOpenSubmit(false);
  const handleLogModalOpenSubmit = () => setLogModalOpenSubmit(true);
  const [logModalOpenUpdate, setLogModalOpenUpdate] = useState(false);
  const handleLogModalCloseUpdate = () => setLogModalOpenUpdate(false);
  const [isApiCalled, setIsApiCalled] = useState(false);
  const handleLogModalOpenUpdate = () => setLogModalOpenUpdate(true);
  const [rowData, setRowData] = useState();
  useEffect(() => {
    fetchmanagetolerancelist(setAllToleranceLists)
    fetchqualitydetails(setQualityParamDetails)
  }, []);
  useEffect(() => {
    if ((edittolerancelists?.statusCde === '100') || (deletetolerancelists?.statusCde === '100') || (addtolerancelists?.statusCde === '100')) {
      setDetails([])
      setFetchDetails([])
      setEdit(false)
      setAdd(false)
      SetshowAdd(true)
      fetchmanagetolerancelist(setAllToleranceLists)
      fetchqualitydetails(setQualityParamDetails)
      navigate('/qualitydashboard/managetolerance')
    }
  }, [edittolerancelists, deletetolerancelists, addtolerancelists]);
  useEffect(() => {
    if (alltolerancelists) {
      const tempArr = []
      alltolerancelists?.map((item, index) => {
        tempArr.push({
          "id": item?.id,
          "indexid": index,
          "qualityParameter": item?.qualityParameter,
          "materialCode": item?.materialCode,
          "toleranceLimit": item?.toleranceLimit,
          "unitOfMeasurement": item?.unitOfMeasurement,
          "createdStr": item?.createdStr,
          "crtdBy": item?.crtdBy,
          "QualityparameterText": item?.qualityParameter,
          "minValue": item?.minValue,
          "maxValue": item?.maxValue,
          "type": ''
        });
      })
      setFetchDetails(tempArr);
    }
  }, [alltolerancelists]);
  useEffect(() => {
    if (details.qualityParameter) {
      fetchdetails?.map(item => {
        if (item?.type === "add" || item?.type === "Edit") {
console.log("inside")
          setDetails(prevState => {
           return { ...prevState, unitOfMeasurement: item?.unitOfMeasurement }
          })
        }
      }
      )
      if (details?.qualityParameter !== 'NewQualityParam') {
        setDetails(
          prevState => {
            return{ ...prevState, QualityparameterText: '' }
          })
      }
    }
  }, [details?.qualityParameter, fetchdetails]);
  const handleCloseMenu = () => {
    setOpen(null);
    setOpenId('');
    SetshowAdd(true);
  };
  const handleOpenMenu = (event, row) => {
    setOpen(event.currentTarget);
    setOpenId(row?.id)
    SetshowAdd(false)
    setSelectedRow(row)
  };

  const onConfirmDelete = () => {
    handleLogModalCloseDelete();
    addmanagetolerancelist(fetchdetails.find((item) => item.id  === selectedId), setAddToleranceLists, "Delete")
       
  }

  const deletemanagetolerance = (id) => {
    setOpen(false)
    setSelectedId(id);
    handleLogModalOpenDelete();
  }

  const editmanagetolerance = (id) => {
    setOpen(false)
    setEdit(true)
    if((selectedRow?.qualityParameter === 'NodeLength') || (selectedRow?.qualityParameter === 'Thickness') || (selectedRow?.qualityParameter === 'Age')) {
    setShowRange(true)
      setShowTolaranceLimit(false)
    } 
    else {
      setShowRange(false)
      setShowTolaranceLimit(true)
    } 
    setEditId(id)
    ByIdFetchmanagetolerance(id, setFetchByIdToleranceLists)
    getqualitymaterialcode(setAllMaterialCode)
    const quatempArr = (fetchdetails?.map(item => {
      if (item?.id === id) {
        item.type = 'Edit'
        qualityParamDetails?.Quality_parameter?.includes(item?.QualityparameterText) ? setShowQuaparam(false) : setShowQuaparam(true)
      }
      return item;
    }
    ))
    setFetchDetails(quatempArr);
  }

  const handleChange = (e, selectedId) => {
    if(e.target.name === "QualityparameterText") {
      setDetails({ ...details, [e.target.name]: e.target.value })
    }
    else {
      setDetails({ ...details, [e.target.name]: e.target.value })
    }
    //===========================table array set ================////////////////
    const tempArr = (fetchdetails?.map(item => {
      if (item?.id === selectedId) {
        if ((e.target.name === 'qualityParameter') && (e.target.value === 'Age')) {
          item.unitOfMeasurement = 'YEARS'
          item[e.target.name] = e.target.value
        }
        else if ((e.target.name === 'qualityParameter') && ((e.target.value === 'Thickness') || (e.target.value === 'NodeLength'))) {
          item.unitOfMeasurement = 'CM'
          item[e.target.name] = e.target.value
        }
        else if (e.target.name === 'qualityParameter') {
          item.unitOfMeasurement = '%'
          item[e.target.name] = e.target.value
        }
        else {
          item[e.target.name] = e.target.value
        }

      }
      return item;
    }
    ))
    setFetchDetails(tempArr);
    //===========================table array set ================////////////////
    //===========================details array set ================////////////////
    if (e.target.name === 'QualityparameterText') {
      setDetails({ ...details, [e.target.name]: e.target.value })
    }
    if (e.target.name === 'qualityParameter') {
      e.target.value === 'NewQualityParam' ? setShowQuaparam(true) : setShowQuaparam(false)
      e.target.value === 'Age' ? setDetails({ ...details, qualityParameter: e.target.value }) : setDetails({ ...details, qualityParameter: e.target.value })
      if ((e.target.value === 'NodeLength') || (e.target.value === 'Thickness') || (e.target.value === 'Age')) {
        setDetails({ ...details, toleranceLimit: '', [e.target.name]: e.target.value, QualityparameterText: '' })
        setShowRange(true)
        setShowTolaranceLimit(false)
        const checkadd = (fetchdetails?.map(item => {
          if (item?.type === "add" || item?.type === "Edit") {
            item.toleranceLimit = ''
          }
          return item
        }
        ))
        setFetchDetails(checkadd);
      }
      else {
        if (e.target.value === 'NewQualityParam') {
          setDetails({ ...details, minValue: '', maxValue: '', [e.target.name]: e.target.value })
        }
        else {
          setDetails({ ...details, minValue: '', maxValue: '', [e.target.name]: e.target.value, QualityparameterText: '' })
        }
        setShowRange(false)
        setShowTolaranceLimit(true)
        const checkadd = (fetchdetails?.map(item => {
          if (item?.type === "add" || item?.type === "Edit") {
            item.minValue = ''
            item.maxValue = ''
          }
          return item
        }
        ))
        setFetchDetails(checkadd);
      }

    }
    setDetails({ ...details, [e.target.name]: e.target.value })
    //===========================details array set ================////////////////
  }
  const handleCancelDetails = (e) => {
    setEdit(false)
    setDetails([])
    setAdd(false)
    SetshowAdd(true)
    const tempArr = [...fetchdetails]
    tempArr.shift();
    setFetchDetails(tempArr)
  }
  const edithandleCancelDetails = (e, rowdetails) => {
    setEdit(false)
    setAdd(false)
    SetshowAdd(true)
    setDetails([])
    fetchmanagetolerancelist(setAllToleranceLists)
  }

// const onConfirmSubmit = () => {
//   handleLogModalCloseSubmit();
//   addmanagetolerancelist(details, setAddToleranceLists, "Create")
// }

    const onConfirmSubmit = async () => {
        if (isApiCalled) return;
        setIsApiCalled(true);
        try {
            await addmanagetolerancelist(details, setAddToleranceLists, "Create");
            await new Promise((resolve) => setTimeout(resolve, 1000));
        } catch (error) {
            console.error("API failed:", error);
        } finally {
            setLogModalOpenSubmit(false);;
            setIsApiCalled(false);
        }
    };

  const onAddTolerance = (e) => {
    if ((details?.qualityParameter || details?.QualityparameterText) && details?.materialCode && (details?.toleranceLimit || (details?.maxValue && details?.minValue))) {
      const datacheck = alltolerancelists?.find(item => (((item?.qualityParameter === details?.qualityParameter) || ((item?.qualityParameter === details?.QualityparameterText))) && (item?.materialCode === details?.materialCode)))
      if (datacheck) {
        toast.error('Already Data Available')
      }
      else {
        handleLogModalOpenSubmit();
      }
    }
    else {
      toast.error('Please Provide Required Fields')
    }
  }

  const handleAdd = () => {
    setDetails([])
    getqualitymaterialcode(setAllMaterialCode)
    setAdd(true)
    setShowQuaparam(false)
    const tempArr = [...fetchdetails]
    tempArr.unshift({
      "id": '',
      "indexid": fetchdetails.length + 2,
      "qualityParameter": '',
      "materialCode": '',
      "toleranceLimit": '',
      "unitOfMeasurement": '',
      "createdStr": '',
      "crtdBy": '',
      "QualityparameterText": '',
      "type": 'add',
      "minValue": '',
      "maxValue": '',
    });
    setFetchDetails(tempArr)
    SetshowAdd(false)
  };

// const onConfirmUpdate = () => {
//   handleLogModalCloseUpdate();
//   addmanagetolerancelist(rowData, setAddToleranceLists, "Update")
// }

   const onConfirmUpdate = async () => {
        if (isApiCalled) return;
        setIsApiCalled(true);
        try {
            await addmanagetolerancelist(rowData, setAddToleranceLists, "Update");
            await new Promise((resolve) => setTimeout(resolve, 1000));
        } catch (error) {
            console.error("API failed:", error);
        } finally {
            setLogModalOpenUpdate(false);
            setIsApiCalled(false);
        }
    };

  const handleEditDetails = (e, rowdetails, fetchbyidtolerancelists) => {
    const datacheck = ((details?.qualityParameter || details?.QualityparameterText) && details?.materialCode) ? alltolerancelists?.find(item => (((item?.qualityParameter === details?.qualityParameter) || ((item?.qualityParameter === details?.QualityparameterText))) && (item?.materialCode === details?.materialCode)))
      : (details?.qualityParameter || details?.QualityparameterText) ? alltolerancelists?.find(item => (((item?.qualityParameter === details?.qualityParameter) || (item?.qualityParameter === details?.QualityparameterText)) && (item?.materialCode === fetchbyidtolerancelists?.materialCode)))
        : alltolerancelists?.find(item => ((item?.qualityParameter === fetchbyidtolerancelists?.qualityParameter) && (item?.materialCode === details?.materialCode)))
    if (datacheck) {
      toast.error('Already Data Available')
    }
    else {
      setRowData(rowdetails);
      handleLogModalOpenUpdate();}
  }
  const columns = [{
    field: 'qualityParameter', headerName: 'Quality parameter', width: 180,
    renderCell: (params) => {
      const handleKeyDown = (event) => {
        if (event.key === ' ') {
          event.stopPropagation(); // Stops event bubbling to prevent row selection
        }
      };
      return (
        ((params?.row?.indexid > fetchdetails?.length))
          ?
          <>
            <FormControl sx={{ width: '100%', paddingRight: '3%' }} >
              <InputLabel id="Qualityparameter-label" sx={showQuaparam ? { mt: 2 } : { mt: 0 }}>Quality Parameter</InputLabel>
              <Select
                label="Qualityparameter"
                labelId="Qualityparameter-label"
                name="qualityParameter"
                onChange={(e) => handleChange(e, params?.row?.id)}
                value={params?.row?.qualityParameter}
                size='small'
                sx={showQuaparam ? { width: '25vh', mt: 2 } : { width: '25vh', padding: "3%" }}
              >
                <MenuItem><em>Select</em></MenuItem>
                {
                  qualityParamDetails?.Quality_parameter?.map((quaparamlist) =>
                    <MenuItem key={quaparamlist} value={quaparamlist}>{quaparamlist}</MenuItem>

                  )}
                <MenuItem value="NewQualityParam">Add New Quality Parameter</MenuItem>
              </Select>
              {showQuaparam &&
                <TextField
                  required
                  id="outlined-required"
                  label="Qualityparameter"
                  name="QualityparameterText"
                  size='small'
                  onKeyDown={handleKeyDown}
                  inputProps={{
                    maxLength: 50
                }}
                  value={params?.row?.QualityparameterText}
                  onChange={(e) => handleChange(e, params?.row?.id)}
                  sx={{ mt: 1, pb: 1, width: '25vh' }}
                />
              }
            </FormControl>
          </>
          :
          <div>{params?.value}</div>
      )
    }
  },
  {
    field: 'materialCode', headerName: 'Material Code', width: 180,
    renderCell: (params) => {
      return (
        ((params?.row?.indexid > fetchdetails?.length))
          ?
          <FormControl sx={{ width: '100%', paddingRight: '3%' }}>
            <InputLabel id="materialcode-label">Material Code</InputLabel>
            <Select
              label="Material Code"
              labelId="materialcode-label"
              id="materialCode"
              name="materialCode"
              size='small'
              onChange={(e) => handleChange(e, params?.row?.id)}
              value={params?.row?.materialCode}
              sx={{ width: '23vh', padding: "3%" }}
            >
              <MenuItem><em>Select</em></MenuItem>
              {
                allMaterialCode?.Material_code?.map((materialcodelist) =>
                  <MenuItem key={materialcodelist} value={materialcodelist}>{materialcodelist}</MenuItem>

                )}
            </Select>
          </FormControl>
          :
          <div>{params?.value}</div>
      )
    }
  },
  {
    field: 'toleranceLimit', headerName: 'Tolerance Limit(%)',
    width: 150,
    renderCell: (params) => {
      return (
        showTolaranceLimit && ((isEdit && (editId === params?.row?.id)) || (params?.row?.indexid > fetchdetails?.length))
          ?
          <TextField
            disabled={showTolaranceLimit ? false : true}
            id="outlined-number"
            label="ToleranceLimit"
            type="number"
            onFocus={handleNumberFieldFocus}
            InputLabelProps={{
              shrink: true,
            }}
            name="toleranceLimit"
            onChange={(e) => handleChange(e, params?.row?.id)}
            value={params?.row?.toleranceLimit}
            size='small'
            onKeyDown={(evt) => typeNumberValid(evt)}
            sx={{ width: '25vh' }}
          />
          :
          <div>{params?.value === 0 ? '' : params?.value}</div>
      )
    }
  },
  {
    field: 'minValue', headerName: 'Min Value', width: 150,
    renderCell: (params) => {
      return (
        showRange && ((isEdit && (editId === params?.row?.id)) || (params?.row?.indexid > fetchdetails?.length)) ?
          <TextField
            disabled={showRange ? false : true}
            id="outlined-number"
            InputLabelProps={{
              shrink: true,
            }}
            label="Min Value"
            type="number"
            onFocus={handleNumberFieldFocus}
            name="minValue"
            onChange={(e) => handleChange(e, params?.row?.id)}
            value={params?.row?.minValue}
            size='small'
            onKeyDown={(evt) => typeNumberValid(evt)}
            sx={{ width: '25vh' }}
          />
          :

          <div>{params?.value}</div>
      )
    }
  },
  {
    field: 'maxValue', headerName: 'Max Value', width: 150,
    renderCell: (params) => {
      return (
        showRange && ((isEdit && (editId === params?.row?.id)) || (params?.row?.indexid > fetchdetails?.length)) ?
          <TextField
            disabled={showRange ? false : true}
            id="outlined-number"
            label="Max Value"
            type="number"
            onFocus={handleNumberFieldFocus}
            InputLabelProps={{
              shrink: true,
            }}
            name="maxValue"
            onChange={(e) => handleChange(e, params?.row?.id)}
            value={params?.row?.maxValue}
            size='small'
            onKeyDown={(evt) => typeNumberValid(evt)}
            sx={{ width: '25vh' }}
          />
          :

          <div>{params?.value}</div>
      )
    }
  },
  {
    field: 'unitOfMeasurement', headerName: 'UOM', width: 150,
    renderCell: (params) => {
      return (
        ((isEdit && (editId === params?.row?.id)) || (params?.row?.indexid > fetchdetails?.length))
          ?
          <TextField
            disabled
            id="outlined-required"
            variant="filled"
            label="UOM"
            name="unitOfMeasurement"
            size='small'
            onChange={(e) => handleChange(e, params?.row?.id)}
            value={params?.row?.unitOfMeasurement}
            sx={{ width: '25vh' }}
          />
          :
          <div>{params?.value}</div>
      )
    }
  },
  {
    field: 'createdStr', headerName: 'Created On', width: 150,
    renderCell: (params) => {
      return (
        params?.row?.indexid > fetchdetails?.length
          ?
          <TextField
            disabled
            id="outlined-disabled"
            variant="filled"
            label="CreatedOn"
            value={date}
            size='small'
            sx={{ width: '25vh' }}
          />
          :
          <div>{fDate(params?.value, 'dd/MM/yyyy')}</div>
      )
    }
  },
  {
    field: 'crtdBy', headerName: 'Created By', width: 200,
    renderCell: (params) => {
      return (
        params?.row?.indexid > fetchdetails?.length
          ?
          <TextField
            disabled
            id="outlined-disabled"
            variant="filled"
            label="CreatedBy"
            defaultValue={checkUserDetails}
            size='small'
            sx={{ width: '100%' }}
          />
          :
          <div>{params?.value}</div>
      )
    }
  },
  {
    field: "actions",
    headerName: "Actions",
    sortable: false,
    width: 250,
    disableClickEventBubbling: true,
    renderCell: (params) => {
      return (
        (isEdit && (editId === params?.row?.id))
          ?
          <>
            <Button sx={{ minWidth: 100 }} variant="contained" onClick={(e) => handleEditDetails(e, params?.row, fetchbyidtolerancelists)}>Save</Button>
            <Button sx={{ minWidth: 100, ml: 2 }} variant="outlined" onClick={(e) => edithandleCancelDetails(e, params?.row)}>Cancel</Button>
          </>
          :
          params?.row?.indexid > fetchdetails?.length
            ?
            <>
              <Button sx={{ minWidth: 100 }} variant="contained" onClick={(e) => onAddTolerance(e)}>Save</Button>
              <Button sx={{ minWidth: 100, ml: 2 }} variant="outlined" onClick={(e) => handleCancelDetails(e)}>Cancel</Button>
            </>
            :
            <div className="d-flex justify-content-between align-items-center" style={{ cursor: "pointer" }}>
              <IconButton size="large" color="inherit" onClick={(e) => handleOpenMenu(e, params?.row)}>
                <Iconify icon={'eva:more-vertical-fill'} />
              </IconButton>
            </div>
      );
    }
  }
  ]
  return (
    <>
      {/* {
        (isLoading) ?
          <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", height: "80vh" }}>
            <img src={loader} alt="loading..." />
          </div>
          : */}
          <Container maxWidth="xxl">
            <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
              <Typography variant="h5" gutterBottom>
                Manage Tolerance Limit
              </Typography>
              <Button onClick={handleAdd} disabled={!showAdd} variant="contained" startIcon={<AddIcon />}>
                ADD
              </Button>
            </Stack>
            <Box sx={{ height: 480, width: '100%' }}>
              {fetchdetails && <DataGrid
                rows={fetchdetails}
                columns={columns}
                pageSize={5}
                rowsPerPageOptions={[5]}
                rowHeight={80}
                components={{ Toolbar: QuickSearchToolbar }}
              />
              }
            </Box>
            <ConfirmationPopover onOpen={logModalOpenDelete} onConfirm={onConfirmDelete} action="Delete" onClose={handleLogModalCloseDelete} />
            <ConfirmationPopover onOpen={logModalOpenSubmit} onConfirm={onConfirmSubmit} action="Submit" onClose={handleLogModalCloseSubmit} />
            <ConfirmationPopover onOpen={logModalOpenUpdate} onConfirm={onConfirmUpdate} action="Update" onClose={handleLogModalCloseUpdate} />
             </Container>
      {/* } */}
      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 1,
            width: 140,
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <MenuItem onClick={(e) => editmanagetolerance(openId)}>
          <Iconify icon={'clarity:assign-user-solid'} sx={{ mr: 2 }} />
          Edit
        </MenuItem>
        <MenuItem onClick={(e) => deletemanagetolerance(openId)}>
          <Iconify icon={'eva:checkmark-circle-2-fill'} sx={{ mr: 2 }} />
          Delete
        </MenuItem>
      </Popover>
    </>
  )

}